import en from './api.en.md?raw';
import zhCN from './api.zh-CN.md?raw';
import zhTW from './api.zh-TW.md?raw';

export const DEFAULT_API_DOC_LANGUAGE = 'en';

export const apiDocMarkdownByLanguage = {
  en,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
} as const;

export type ApiDocLanguage = keyof typeof apiDocMarkdownByLanguage;

export function getApiDocMarkdown(language?: string): string {
  if (!language) return apiDocMarkdownByLanguage[DEFAULT_API_DOC_LANGUAGE];

  const normalized = normalizeApiDocLanguage(language);
  return apiDocMarkdownByLanguage[normalized] ?? apiDocMarkdownByLanguage[DEFAULT_API_DOC_LANGUAGE];
}

function normalizeApiDocLanguage(language: string): ApiDocLanguage {
  if (language in apiDocMarkdownByLanguage) {
    return language as ApiDocLanguage;
  }

  const baseLanguage = language.split('-')[0];
  if (baseLanguage === 'zh') return 'zh-CN';
  if (baseLanguage === 'en') return 'en';

  return DEFAULT_API_DOC_LANGUAGE;
}
